import { render, staticRenderFns } from "./orderPreference.vue?vue&type=template&id=199ea4b8&"
import script from "./orderPreference.vue?vue&type=script&lang=js&"
export * from "./orderPreference.vue?vue&type=script&lang=js&"
import style0 from "./orderPreference.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports